import "./Public.css";
import checked from "../assets/checked.png";
import Loc from "../../Loc/Loc";

interface SuccessDownloadProps {
    setAccess: React.Dispatch<React.SetStateAction<boolean>>;
    setWaitingForCode: React.Dispatch<React.SetStateAction<boolean>>;
    setEnterMail: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function SuccessDownload(props: SuccessDownloadProps) {
    const handleBackHome = () => {
        props.setAccess(false);
        props.setWaitingForCode(false);
        props.setEnterMail(false);
    }

    return (
        <div className="SuccessDownload">
            <div style={{color: 'white', fontSize: '4rem'}}>{Loc.trad().SuccessDownloadSuccess}</div>
            <div><img src={checked} alt="logo verifié" style={{width: '150px', marginTop: '25px'}}></img></div>
            <button className="btn btn-secondary btn-lg" style={{marginTop: '50px'}} onClick={handleBackHome}>{Loc.trad().SuccessDownloadBack}</button>
        </div>
    )
}